import React, { useRef } from "react";
import { useNavigate } from "react-router-dom"; // Import do nawigacji
import "../styles/Host.css";

const HostPanel = ({ items }) => {
  const containerRef = useRef(null);
  const navigate = useNavigate(); // Hook do nawigacji

  return (
    <div className="host-panel-container">
      <div className="host-panel" ref={containerRef}>
        {items.reduce((acc, item, index) => {
          if (index % 2 === 0) {
            acc.push([item]);
          } else {
            acc[acc.length - 1].push(item);
          }
          return acc;
        }, []).map((pair, index, array) => (
          <div key={index} className="host-row">
            {pair.map((item, subIndex) => (
              <div
                key={subIndex}
                className={`host-item ${!item.navigate ? "host-item-inactive" : ""}`}
                onClick={() => {
                  if (item.navigate) {
                    navigate(item.navigate); 
                  }
                }}
              >
                <item.icon className="host-image" />
                <div className="host-label">{item.label}</div>
              </div>
            ))}
            {pair.length === 1 && index === array.length - 1 && (
              <div className="host-item-empty"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HostPanel;